var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.663,
    height: 183.873,
    viewBox: "0 0 109.663 183.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down",
    transform: "translate(-228.338 -230)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(280 257)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    transform: "translate(280 244)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 5,
    height: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    transform: "translate(280 230)",
    fill: "none",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375,0,6.75,6H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.375 2.039735555648804 L 1.709851264953613 5 L 5.040148735046387 5 L 3.375 2.039735555648804 M 3.375 0 L 6.75 6 L 0 6 L 3.375 0 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-arrow-down-1532643",
    transform: "translate(127.386 225.095)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M279.666,134.49l-53.983,54.035a.854.854,0,0,1-1.213,0L170.5,134.49a.858.858,0,1,1,1.213-1.213l52.513,52.583V46.887a.854.854,0,1,1,1.709,0V185.86l52.513-52.513a.858.858,0,0,1,1.213,1.213Z",
    transform: "translate(-69.298 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.d8188272c992e69b8e0f0a8ddfbcdccd.svg";
export { ForwardRef as ReactComponent };